import { render, staticRenderFns } from "./recordingdown.vue?vue&type=template&id=2909ef07&scoped=true"
import script from "./recordingdown.vue?vue&type=script&lang=js"
export * from "./recordingdown.vue?vue&type=script&lang=js"
import style0 from "./recordingdown.vue?vue&type=style&index=0&id=2909ef07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909ef07",
  null
  
)

export default component.exports